/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Radio,
  Row,
  Col,
  Form,
  Input,
  Button,
  Select,
  message,
  Spin,
  Modal,
} from "antd";
import Heading from "../CpOnboardingNew/Heading";
import API from "../../api";
import urls from "../../api/urls";
import {
  checkAlphabets,
  checkSpecialCharacter,
  checkSpace,
  checkNumbervalue,
  getUserAndPremiseId,
} from "../../utils";
import PinCodeValidator from "../../components/PincodeValidator";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { customerOnboardingAPI } from "../../api/LeadApi";
import AutoCompleteAddress from "../FirstMile/CrediteBooking/AutoCompleteAddress";
import CreateKYC from "../../components/CreateKYC";
import BankDetails from "../../components/BankDetails";
const {
  CREATE_BRANCH,
  VERIFY_PHONE_NUM,
  SEND_SMS_PHONE,
  VERIFY_PHONE_OTP,
  SEND_OTP,
  GET_BRANCH_DETAILS,
  PATCH_BRANCH_DETAILS,
} = urls;
const getUserInfo = getUserAndPremiseId();
const premiseId = getUserInfo?.premiseId;

const BranchAdmin = ({
  handleStepsChange,
  patchCompany,
  getData,
  setCpPinCodeData,
}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [isGstRegister, setIsGstRegister] = useState(true);
  const [visible, setVisible] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [phnOtpVerified, setPhnOtpVerified] = useState(false);
  const [shareParentKyc, setShareKyc] = useState(false);
  const [branchData, setBranchData] = useState(null);
  const [clickedButton, setClickedButton] = useState(null);
  const [parentCompanyData, setParentCompanyData] = useState([]);

  const customerIdCompany = localStorage.getItem("customerIdCompany");

  useEffect(() => {
    if (getData) {
      fillAllFields(getData);
    }
  }, [getData]);

  useEffect(() => {
    getCompanyList();
  }, []);

  const fillAllFields = (data) => {
    fillKycData(data);

    form.setFieldsValue({
      organizationName: data?.organizationName || null,
      number: data?.contactNumbers?.[0]?.number || null,
      email: data?.emails?.[0]?.email || null,
      remark: data?.remark || null,
      cpType: data?.cpType,

      dropRadius: data?.dropRadius,
      nameOfOwner: data?.businessDetail?.nameOfOwner,
      companyName: data?.businessDetail?.companyName || null,

      businessName: data?.businessDetail?.businessName || null,
      natureOfBusiness: data?.businessDetail?.natureOfBusiness || null,
      bankDetails: data?.bankDetails || [],
      shareKyc:
        data?.metadata?.find((item) => item.key === "SHARED_KYC")?.value ===
        "true",
      parentKyc:
        data?.metadata?.find((item) => item.key === "SHARED_KYC_COMPANY_ID")
          ?.value || null,
    });

    setShareKyc(
      data?.metadata?.find((item) => item.key === "SHARED_KYC")?.value
    );
  };

  useEffect(() => {
    if (parentCompanyData?.length > 0) {
      form.setFieldsValue({
        parentKyc:
          parseInt(
            getData?.metadata?.find(
              (item) => item.key === "SHARED_KYC_COMPANY_ID"
            )?.value
          ) || null,
      });
    }
  }, [getData, parentCompanyData]);

  const fillKycData = (data) => {
    const GST =
      data?.kycDocuments.find((doc) => doc.idType === "GST")?.idNumber || null;
    const PAN =
      data?.kycDocuments.find((doc) => doc.idType === "PAN")?.idNumber || null;
    const AADHAR =
      data?.kycDocuments.find((doc) => doc.idType === "AADHAR")?.idNumber ||
      null;

    const TAN =
      data?.kycDocuments.find((doc) => doc.idType === "TAN")?.idNumber || null;

    const address = data?.addresses?.find((e) => e?.type === "gstAddress");
    form.setFieldsValue({
      organizationName: data?.organizationName || null,

      line1: address?.line1,
      line2: address?.line2,
      pincode: address?.postalCode,
      GST,
      PAN,
      AADHAR,
      TAN,
      gstRegistred: data?.kycDocuments?.length === 0 || GST ? true : false,
      businessName: data?.businessDetail?.businessName || null,
      natureOfBusiness: data?.businessDetail?.natureOfBusiness || null,
    });
  };
  const getCompanyList = async () => {
    const response = await customerOnboardingAPI.getCompanyByCP({
      premiseId: premiseId,
    });

    setParentCompanyData(
      response?.response?.data?.data?.map((item) => ({
        ...item,
        value: item?.companyId,
        label: item?.organizationName,
      }))
    );
  };

  const resetKycField = () => {
    form.setFieldsValue({
      organizationName: null,

      line1: null,
      line2: null,
      pincode: null,
      GST: null,
      PAN: null,
      AADHAR: null,
      TAN: null,
      gstRegistred: null,
      businessName: null,
      natureOfBusiness: null,
    });
  };

  const typeOfBusinessOptions = [
    {
      value: "Individual",
      label: "Individual",
    },
    {
      value: "Proprietorship",
      label: "Proprietorship",
    },
    {
      value: "Private limited",
      label: "Private limited",
    },
    {
      value: "Public limited",
      label: "Public limited",
    },
    {
      value: "LLP",
      label: "LLP",
    },
    {
      value: "Partnership",
      label: "Partnership",
    },
  ];

  const radioChange = (e) => {
    form.setFieldsValue({
      isGstRegister: e.target.value,
      aadharNumber: null,
      gstNumber: null,
    });
    setIsGstRegister(e.target.value);
    setShowVerify(false);
  };

  const createBasicDetails = async (val) => {
    setLoading(true);
    const checkBtn = clickedButton === "saveAndContinueButton";
    setCpPinCodeData(val?.pincode);
    let payload = {
      customerType: "COMPANY",
      organizationName: val?.organizationName,
      source: "website",

      pincode: val?.pincode,
      emails: [{ email: val?.email, type: "personal" }],
      contactNumbers: [{ number: val?.number, type: "default" }],
      addresses: [
        {
          line1: val?.line1,
          line2: val?.line2,
          postalCode: val?.pincode,
          type: "gstAddress",
        },
      ],
      businessDetail: {
        nameOfOwner: val?.nameOfOwner,
        natureOfBusiness: val?.natureOfBusiness,
        businessName: val?.businessName || null,
      },
      ...(shareParentKyc && {
        metadata: [
          {
            key: "SHARED_KYC",
            value: true,
          },
          {
            key: "SHARED_KYC_COMPANY_ID",
            value: val?.parentKyc,
          },
        ],
      }),

      bankDetails: val?.bankDetails,
      kycDocuments: [
        {
          idType: "GST",
          idNumber: val?.GST,
          isVerified: false,
        },
        {
          idType: "PAN",
          idNumber: val?.PAN,
          isVerified: false,
        },
        {
          idType: "AADHAR",
          idNumber: val?.AADHAR,
          isVerified: false,
        },
        {
          idType: "TAN",
          idNumber: val?.TAN,
          isVerified: false,
        },
      ].filter((doc) => doc.idNumber),
    };

    if (customerIdCompany === null) {
      let response = await customerOnboardingAPI.createLead(payload);

      if (response?.status) {
        setLoading(false);
        if (checkBtn) {
          handleStepsChange(1);
        }
        message.success(response?.message || "CP added successfully");
        localStorage.setItem(
          "customerIdCompany",
          response?.response?.data?.data?.customerId
        );
      } else {
        message.error(response?.response?.data?.message || "Network error");
        setLoading(false);
      }
    } else {
      setLoading(false);
      patchCompany(payload, checkBtn);
    }
  };

  async function sentGSTOtp() {
    setLoading(true);

    let gst = form.getFieldValue("gstNumber");

    let payload = {
      businessType: form.getFieldValue("businessType"),
      isGstRegistered: form.getFieldValue("isGstRegistered"),
      gstNumber: gst || undefined,
      aadharNumber: form.getFieldValue("aadharNumber"),
      // gstOTP: "1234",
    };
    let response = await API.Api(SEND_OTP).postWithPrmiseHeader(payload);

    if (response?.status) {
      setLoading(false);
      setVisible(false);
      message.success(response?.response?.data);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  }

  ///Verification///
  const checkPhnNumExists = async (values) => {
    setLoading(true);

    let response = await API.Api(VERIFY_PHONE_NUM).post({
      contactNumber: values,
    });
    if (response?.status) {
      setLoading(false);
      if (response?.response?.data === false) {
        message.error("Phone number already exists");
      } else {
        // sentPhoneOtp(values);
        setShowVerify(true);
        setLoading(false);
      }
    } else {
      message.error("Internal server error.");
      setLoading(false);
    }
  };
  const sentPhoneOtp = async () => {
    setLoading(true);

    let phoneNum = form.getFieldValue("phoneNumber");

    let response = await API.Api(SEND_SMS_PHONE).post({
      mobileNo: phoneNum,
    });

    if (response?.response?.data === true) {
      setLoading(false);
      message.info("OTP has sent the given number");
    } else {
      setLoading(false);
      message.error("Failed to send the OTP");
    }
  };
  const handleCloseModal = () => {
    setVisible(false);
  };
  const verifyPhoneOtp = async (values) => {
    setLoading(true);

    let phoneNum = form.getFieldValue("phoneNumber");
    let response = await API.Api(VERIFY_PHONE_OTP).post({
      mobileNo: phoneNum,
      otp: values.otp,
    });

    if (response?.response?.data === true) {
      setLoading(false);

      message.success("Phone number verified successfully");
      setPhnOtpVerified(true);
      setVisible(false);
      setShowVerify(false);
    } else {
      setLoading(false);
      message.error("Wrong OTP");
    }
  };

  ///--///

  return (
    <Spin spinning={loading}>
      <div className="cp-detail-wrapper">
        <Form
          form={form}
          layout={"vertical"}
          onFinish={createBasicDetails}
          className="global-form profile-container-form pl-4 pr-4 p-2"
          scrollToFirstError
          // disabled={!viewOnly}
          initialValues={{ gstRegistred: true, shareKyc: false }}
        >
          <Row gutter={24} className="global-form-row">
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="nameOfOwner"
                  label="Admin Name"
                  onKeyPress={(event) => {
                    if (checkAlphabets(event)) {
                      event.preventDefault();
                    }
                  }}
                  rules={[
                    {
                      message: "Please enter name",
                      required: true,
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter name"
                    maxLength={40}
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="email"
                  label="Email-ID"
                  type="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter E-mail",
                    },
                    {
                      type: "email",
                      message: "The input is not valid E-mail",
                      validateTrigger: "onSubmit",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter E-mail"
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="number"
                  label="Phone number"
                  //hasFeedback={phnOtpVerified}
                  rules={[
                    {
                      required: true,
                      message: "Please enter mobile number",
                    },
                    {
                      pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                      message: "Invalid mobile number",
                    },
                    // () => ({
                    //   validator(rule, value = "") {
                    //     if (value) {
                    //       if (!phnOtpVerified) {
                    //         return Promise.reject("Enter a valid otp");
                    //       } else {
                    //         return Promise.resolve();
                    //       }
                    //     }
                    //   },
                    //   validateTrigger: "onSubmit",
                    // }),
                  ]}
                >
                  <Input
                    disabled={getData?.status?.toLowerCase() === "approved"}
                    onKeyPress={(e) => {
                      if (/[^0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                      if (e.target.value.length >= 10) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="Enter phone number"
                    maxLength={10}
                    // onChange={(e) => {
                    //   if (e.target.value.length === 10) {
                    //     checkPhnNumExists(e.target.value);
                    //   } else {
                    //     // phnOtpVerified
                    //     setPhnOtpVerified(
                    //       branchData?.phoneNumber === e.target.value
                    //         ? true
                    //         : false
                    //     );
                    //     setShowVerify(false);
                    //   }
                    // }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Heading title={"KYC Details"} />
              </Col>

              <Col span={4}>
                <Form.Item
                  label="Share Parent KYC"
                  name="shareKyc"
                  className="d-flex"
                >
                  <Radio.Group
                    value={shareParentKyc}
                    onChange={({ target: { value } }) => {
                      setShareKyc(value);
                      resetKycField();
                    }}
                  >
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>

              {shareParentKyc ? (
                <Col span={8}>
                  <Form.Item
                    label={"Select Company"}
                    name="parentKyc"
                    rules={[
                      {
                        required: true,
                        message: "Select value",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Company"
                      onSelect={(e, data) => fillKycData(data)}
                      options={parentCompanyData}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col span={8} />
              )}

              <CreateKYC
                orgName={"Company"}
                form={form}
                //rgColSpan={6}
                getData={getData}
                disable={shareParentKyc}
              />
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="natureOfBusiness"
                  label="Business Type"
                  rules={[
                    { required: true, message: "Please select business type" },
                  ]}
                >
                  <Select
                    placeholder="Select business type"
                    options={typeOfBusinessOptions}
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="businessName"
                  label="Business Name"
                  rules={[
                    { required: true, message: "Please enter business name" },
                  ]}
                >
                  <Input
                    placeholder="Enter business name"
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Heading title="Bank Details" />
              </Col>
              <Col span={24}>
                <BankDetails
                  disabled={getData?.status?.toLowerCase() === "approved"}
                  form={form}
                />
              </Col>
            </Row>
            <hr className="divider" />
            <div className="flex-end mt-1">
              {getData?.status?.toLowerCase() !== "approved" ? (
                <>
                  <Button htmlType="submit" className="cancel-btn ml-1">
                    SAVE
                  </Button>
                  <Button
                    htmlType="submit"
                    id="saveNContinue"
                    onClick={() => setClickedButton("saveAndContinueButton")}
                    className="save-btn  ml-1"
                  >
                    SAVE & CONTINUE
                  </Button>
                </>
              ) : (
                <Button
                  id="saveNContinue"
                  onClick={() => handleStepsChange(1)}
                  className="save-btn  ml-1"
                >
                  NEXT
                </Button>
              )}
            </div>
          </Row>
        </Form>
      </div>
      <Modal
        title={null}
        open={visible}
        maskClosable={false}
        onCancel={handleCloseModal}
        width={400}
        loading={false}
        className="staff-onboard-modal"
        footer={
          <>
            <div className="d-flex flex-end">
              <Button
                htmlType="submit"
                onClick={modalForm.submit}
                className="save-btn ml-1"
              >
                SUBMIT
              </Button>
            </div>
          </>
        }
      >
        <div>
          <Form
            form={modalForm}
            onFinish={verifyPhoneOtp}
            layout={"vertical"}
            className="global-form"
          >
            <Row
              justify=""
              span={24}
              className="global-form-row mt-2"
              gutter={20}
              style={{ padding: "0 30px" }}
            >
              <Col span={24}>
                <Form.Item
                  name="otp"
                  label="OTP"
                  rules={[
                    {
                      message: "OTP is required",
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder="Enter OTP" maxLength={6} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </Spin>
  );
};

export default BranchAdmin;
